export default __webpack_public_path__ + "static/media/modal1.83693dc9.png";